import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { AgentRecord } from '../../models/dashboard.model';
import { $Locale } from '@hubio/hubio-common-components';
import { MatDialog } from '@angular/material/dialog';
import { FileDropModalComponent } from '../../components/file-drop-modal/file-drop-modal.component';
import { Subject, Subscription } from 'rxjs';
import { SnackbarService } from '@core/services/snackbar.service';

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss']
})
export class AgentsComponent implements OnInit {

  public dataSubject: Subject<AgentRecord[]> = new Subject<AgentRecord[]>();
  public data: AgentRecord[];
  private subscriptions: Subscription[] = []

  constructor(
    private dashboardService: DashboardService,
    public $Locale: $Locale,
    private dialog: MatDialog,
    private snackBarService: SnackbarService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  private getData(): void {
    this.subscriptions.push(this.dashboardService.getAllAgents().subscribe((agents) => {
      this.dataSubject.next(agents);
      this.data = agents;
    }));
  }

  private updateAgentData(newAgents: AgentRecord[]): void {
    newAgents.forEach((newAgent) => {
      if (!this.data.some((existingElement) => existingElement.code === newAgent.code)) {
        this.data.push(newAgent);
      }
    });
    this.dataSubject.next(this.data);
  };

  public insertAgentsFromCsv(): void {
    const dialogRef = this.dialog.open(FileDropModalComponent);
    this.subscriptions.push(dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        this.dashboardService.updateAgents(result.data).subscribe((agents) => {
          this.updateAgentData(agents)
          this.snackBarService.open(`Agents updated with ${agents.length} change${agents.length != 1 ? 's' : ''}`);
        });
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe())
  }
}
